import { useMemo } from 'react';

const RISK_COLORS = {
  LOW: { bg: 'bg-emerald-100', text: 'text-emerald-700', stroke: '#10b981' },
  MEDIUM: { bg: 'bg-amber-100', text: 'text-amber-700', stroke: '#f59e0b' },
  HIGH: { bg: 'bg-orange-100', text: 'text-orange-700', stroke: '#f97316' },
  CRITICAL: { bg: 'bg-red-100', text: 'text-red-700', stroke: '#ef4444' },
};

export default function RiskGaugeChart({ score = 0, riskLevel = 'LOW', trend = 'stable', size = 160 }) {
  const colors = RISK_COLORS[riskLevel] || RISK_COLORS.LOW;
  const radius = (size - 20) / 2;
  const circumference = Math.PI * radius; // Half circle
  const offset = circumference - (score / 100) * circumference;

  const trendIcon = useMemo(() => {
    if (trend === 'improving') return { symbol: '\u2191', color: 'text-emerald-500', label: 'Improving' };
    if (trend === 'declining') return { symbol: '\u2193', color: 'text-red-500', label: 'Declining' };
    return { symbol: '\u2192', color: 'text-slate-400', label: 'Stable' };
  }, [trend]);

  return (
    <div className="flex flex-col items-center">
      <svg width={size} height={size / 2 + 20} viewBox={`0 0 ${size} ${size / 2 + 20}`}>
        {/* Background arc */}
        <path
          d={`M 10 ${size / 2 + 10} A ${radius} ${radius} 0 0 1 ${size - 10} ${size / 2 + 10}`}
          fill="none"
          stroke="#e2e8f0"
          strokeWidth="12"
          strokeLinecap="round"
        />
        {/* Score arc */}
        <path
          d={`M 10 ${size / 2 + 10} A ${radius} ${radius} 0 0 1 ${size - 10} ${size / 2 + 10}`}
          fill="none"
          stroke={colors.stroke}
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 1s ease-in-out' }}
        />
        {/* Score text */}
        <text
          x={size / 2}
          y={size / 2 - 5}
          textAnchor="middle"
          className="text-3xl font-bold"
          fill="currentColor"
        >
          {Math.round(score)}
        </text>
        <text
          x={size / 2}
          y={size / 2 + 15}
          textAnchor="middle"
          className="text-xs"
          fill="#94a3b8"
        >
          / 100
        </text>
      </svg>
      <div className="flex items-center gap-2 mt-1">
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${colors.bg} ${colors.text}`}>
          {riskLevel}
        </span>
        <span className={`text-sm font-medium ${trendIcon.color}`} title={trendIcon.label}>
          {trendIcon.symbol} {trendIcon.label}
        </span>
      </div>
    </div>
  );
}
